import styled from "styled-components"

import { ApiTypes, UITypes } from "types"

export interface ClientValues {
  homeowner_name: string
  email: string
  phone: string
  address1: string
  state: UITypes.Option[]
  city: UITypes.Option[]
}

export interface AssignmentValues {
  csmName: string
  contractor: UITypes.Option[]
  internalNote: string
  serialNumbers: string[]
}

export const SectionTitle = styled.div`
  margin: 0 -20px;
`

const toOption = (item?: { id: number; name: string } | null): UITypes.Option[] =>
  item ? [{ value: item.id, label: item.name }] : []

export const getClientValues = (referral: ApiTypes.Model.Referral): ClientValues => ({
  homeowner_name: referral.homeowner_name ?? "",
  email: referral.homeowner_email ?? "",
  phone: referral.homeowner_phone ?? "",
  address1: referral.property_address1 ?? "",
  state: toOption(referral.state),
  city: toOption(referral.city),
})

export const getAssignmentValues = (referral: ApiTypes.Model.Referral): AssignmentValues => ({
  csmName: referral.csm_name ?? "",
  contractor:
    referral.contractor_id != null ? [{ value: referral.contractor_id, label: referral.contractor_name ?? "" }] : [],
  internalNote: referral.internal_note ?? "",
  serialNumbers: Array.from(
    { length: Math.max(referral.thermostat_quantity ?? 1, referral.thermostat_serial_numbers?.length ?? 0) },
    (_, index) => referral.thermostat_serial_numbers?.[index] ?? "",
  ),
})

export const normalizeClient = (values: ClientValues) => ({
  homeowner_name: values.homeowner_name.trim(),
  email: values.email.trim(),
  phone: values.phone.trim(),
  address1: values.address1.trim(),
  state: values.state[0]?.value ?? null,
  city: values.city[0]?.value ?? null,
})

export const normalizeAssignment = (values: AssignmentValues) => ({
  csmName: values.csmName.trim(),
  contractor: values.contractor[0]?.value ?? null,
  internalNote: values.internalNote.trim(),
  serialNumbers: values.serialNumbers.map(serial => serial.trim()),
})

export const isSame = (a: object, b: object) => JSON.stringify(a) === JSON.stringify(b)
